/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';
import dayjs from 'dayjs';

// Core
import { Router, Blog } from '@app';
import { Button, Popover, Link } from '@client/components';

// App
import Page from '@/client/pages/university/_layout/_page';
import type { Article } from '@models/types';
import ArticleCard from '@/client/components/Articles/Article';

// Resources
import GaetanPhoto from '@/client/assets/img/testimonials/gaetan.jpeg';
import Screenshot from '@/client/assets/img/illustrations/screenshot.jpg';

/*----------------------------------
- TYPES
----------------------------------*/

const TableOfContent = ({ skeleton }) => (
    <ol class="col txt-left bl-2 pdl-1">
        {skeleton.map(({ title, id, childrens }) => (
            <li>
                <Link class="discrete" to={'#' + id}>{title}</Link>

                {/* {childrens && <TableOfContent skeleton={childrens} />} */}
            </li>
        ))}
    </ol>
)

/*----------------------------------
- CONTROLEUR
----------------------------------*/
Router.page('/blog/:slug', ({ api, data, page }) => {

    const { article } = api.fetch({
        article: Blog.Get({ slug: data.slug }),
    });

    const [showCTA, setShowCTA] = React.useState(false);
    React.useEffect(() => {
        setTimeout(() => {
            setShowCTA(true);
        }, 10000);
    }, []);

    page.metas = {
        ...page.metas,
        'article:published_time': article.created,
        'article:modified_time': article.updated,

        'og:type': 'article',
        'og:image': article.socialImage,
        'og:image:type': 'image/jpeg',
        'og:image:width': '1200px',
        'og:image:height': '630px',
    }

    page.jsonld.push({
        "@type": "NewsArticle",
        "@id": page.url + "/#article",
        "isPartOf": {
            "@id": page.url // WebPage object
        },
        "headline": article.title,
        "datePublished": article.created,
        "dateModified": article.updated,
        "mainEntityOfPage": {
            "@id": page.url // WebPage object
        },
        //"wordCount": 1238,
        "publisher": {
            "@id": "https://unique.domains/#organization"
        },
        "author": {
            "name": "Gaëtan Le Gac",
            "url": "https://gaetan-legac.fr",
            "@id": "https://unique.domains/#author",
            "worksFor": {
                "@id": "https://unique.domains/#organization"
            }
        },
        "image": {
            "@id": page.url + "/#primaryimage" // ImageObject
        },
        //"thumbnailUrl": "https://techcrunch.com/wp-content/uploads/2021/03/GettyImages-918480798.jpg",
        /*"keywords": [
            "Atomico",
            "european venture capital",
            "state of european tech"
        ],*/
        "inLanguage": "en-US",
        "copyrightYear": "2024",
        "copyrightHolder": {
            "@id": "https://unique.domains/#organization"
        }
    }, {
        "@type": "ImageObject",
        "inLanguage": "en-US",
        "@id": page.url + "/#primaryimage",
        "url": article.thumbnail,
        "contentUrl": article.thumbnail,
        "width": '1200px',
        "height": '628px',
        "caption": article.thumbnailAltText
    });

    return (
        <Page title={article.title} description={article.description}
            hideNav class="col al-center">

            <div class="col al-center sp-0" style={{ maxWidth: '1400px' }}>

                <img class="bg img" style={{
                    width: '100%',
                    height: '40vh',
                    marginBottom: '3vh',
                }} src={article.coverImage} alt={article.thumbnailAltText || article.title} />

                <div class="row al-top sp-4 wrap">
                    <div class="col al-center">
                        <article class="w-3-7">

                            <header class="Hero col mgb-2">

                                {article.topics && (
                                    <ul class="row al-left wrap sp-05">
                                        {article.topics.map(topic => (
                                            <li>
                                                <Button type="secondary" size="s" link={'/blog/topic/' + topic.topicInfo.slug}>
                                                    {topic.topicInfo.name}
                                                </Button>
                                            </li>
                                        ))}
                                    </ul>
                                )}

                                <h1 style={{ fontSize: '2.2rem' }}>{article.title}</h1>

                                <p>
                                    {article.description}
                                </p>

                                <div class="row al-left sp-05">

                                    <img class="logo circle mgr-05" src={GaetanPhoto} />

                                    <span>
                                        Gaëtan Le Gac
                                    </span>

                                    &bull;

                                    <span>
                                        {dayjs(article.created).format('DD MMMM YYYY')}
                                    </span>
                                </div>
                            </header>

                            <div class="reading" dangerouslySetInnerHTML={{ __html: article.html }} />

                            {showCTA && (
                                <footer class="card floating pdv-1 row sp-05" style={{
                                    position: 'sticky',
                                    bottom: '1rem',
                                }}>
                                    <div class="col-1 txt-left">
                                        Are you looking for unique domain names?
                                    </div>
                                    <Button size="s" link="/" target="_blank"
                                        onClick={() => setShowCTA(false)}>
                                        Yes
                                    </Button>
                                    <Button size="s" onClick={() => setShowCTA(false)}>
                                        No
                                    </Button>
                                </footer>
                            )}
                        </article>
                    </div>
                    <aside class="col w-2-3">
                        <h2>On this page</h2>
                        <TableOfContent skeleton={article.skeleton} />
                    </aside>
                </div>

                <div class="motion mgt-4">
                    <img src={Screenshot} />
                </div>
            </div>

            {/*parent && parent.childrens.length && (
                <section class="col mgt-2 pdt-2 bt-1">
                    <h2>{parent.title}</h2>
                    <p class="reading w-a-8">
                        {parent.description}
                    </p>
                    
                    <Articles articles={parent.childrens} />
                </section>
            )}

            {related?.length && (
                <section class="col mgt-2 pdt-2 bt-1">
                    <h2>Read Next</h2>
                    <Articles articles={related} />
                </section>
            )}

            {topics?.map(({ name, description, articles }) => articles.length > 0 && (
                <section class="col mgt-2 pdt-2 bt-1">
                    <h2>{name}</h2>
                    <p class="reading w-a-8">
                        {description}
                    </p>
                    <Articles articles={articles} />
                </section>
            ))*/}

            {/* <Discover /> */}

        </Page>
    )
});